import { render, staticRenderFns } from "./contact2.vue?vue&type=template&id=4f26a36c&"
import script from "./contact2.vue?vue&type=script&lang=js&"
export * from "./contact2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports